import { API } from "aws-amplify";
import { getYearlyStatusSummary } from "~/graphql/queries";
import * as APITypes from "~/API";
import { LoaderData } from "~/types";

export const EMPTY_YEARLY_STATUS: APITypes.YearlyStatusSummary = {
  __typename: "YearlyStatusSummary",
  id: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  year: 0,
  createdAt: "",
  updatedAt: "",
  numOccupied: 0,
  numVacant: 0,
  numRenovation: 0,
  expectedRent: 0,
  expectedStayRevenue: 0,
  aggregateIncome: {
    __typename: "IncomeStatement",
    rentRevenue: 0,
    stayRevenue: 0,
    feeRevenue: 0,
    otherRevenue: 0,
    totalRevenue: 0,
    repairExpenses: 0,
    lostRentExpenses: 0,
    renovationExpenses: 0,
    totalExpenses: 0,
    net: 0,
    ownerID: "",
    ownerType: APITypes.OwnerType.User,
  },
  numUnits: 0,
  numBuildings: 0,
  numProperties: 0,
  numServiceRequests: 0,
  numAmenities: 0,
  numAmenityReservations: 0,
  _version: 0,
  _lastChangedAt: 0,
};

export const getYearlyStatus = async (
  reportId: string
): Promise<LoaderData<APITypes.YearlyStatusSummary>> => {
  try {
    const response = (await API.graphql({
      query: getYearlyStatusSummary,
      variables: {
        id: reportId,
      },
    })) as { data?: APITypes.GetYearlyStatusSummaryQuery };

    if (!response.data?.getYearlyStatusSummary) {
      throw new Error("No yearly status summary found");
    }

    return {
      success: true,
      data: response.data?.getYearlyStatusSummary || EMPTY_YEARLY_STATUS,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_YEARLY_STATUS,
      error,
    };
  }
};
